import { NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { AutofocusDirective } from './autofocus/autofocus.directive';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ButtonComponent } from './button/button.component';
import { CardComponent } from './card/card.component';
import { IconComponent } from './icon';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { PasswordDirective } from './password/password.directive';
import { SideDrawerComponent } from './side-drawer/side-drawer.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { StepperComponent } from './stepper/stepper.component';

const COMPONENTS = [
  ButtonComponent,
  BreadcrumbsComponent,
  IconComponent,
  IconButtonComponent,
  CardComponent,
  SideDrawerComponent,
  SpinnerComponent,
  StepperComponent,
];
const DIRECTIVES = [AutofocusDirective, PasswordDirective];

/**
 * @deprecated Please use the standalone components of this library instead of pulling all components with this module
 */
@NgModule({
  exports: [...COMPONENTS, ...DIRECTIVES],
  imports: [GoogleMapsModule, ...COMPONENTS, ...DIRECTIVES],
})
export class BaseModule {}
